import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { ClientService } from './client.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { ClientListComponent } from './list/list.component';

// import { ClientFormComponent } from './form/form.component';
import { TooltipModule } from 'ngx-bootstrap';
import { ClientGuard } from './client.guard';
import { ClientListGuard } from './client-list.guard';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    ClientListComponent,
    // ClientFormComponent,
    // KeysPipe,
  ],
  exports: [
    // ClientFormComponent
  ]
})
export class ClientModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ClientModule,
      providers: [
        ClientService,
        ClientGuard,
        ClientListGuard
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/client/client.module.ts